// extracted by mini-css-extract-plugin
module.exports = {"locl-single-page-layout":"single-page-layout_locl-single-page-layout__DL_bw","locl-single-page-layout__content":"single-page-layout_locl-single-page-layout__content__Xybch"};